import "./graphing-calculator.88926f55.js";


      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb015"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb015"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $7eII2 = parcelRequire("7eII2");

var $e6lF8 = parcelRequire("e6lF8");
const $8eae7ab5226ec05d$var$fetchTestData = async ()=>{
    const response = await fetch(`https://neuroflow.andypai.me/api/mnist?end=100&type=test`);
    const json = await response.json();
    return json;
};
const $8eae7ab5226ec05d$var$drawImage = (image)=>{
    const imageCanvas = document.createElement('canvas');
    const size = 14;
    const scale = size * 8;
    imageCanvas.width = scale;
    imageCanvas.height = scale;
    const ctx = imageCanvas.getContext('2d');
    const imageData = ctx.createImageData(size, size);
    image.forEach((pixel, idx)=>{
        const value = pixel * 255;
        imageData.data[idx * 4 + 0] = value;
        imageData.data[idx * 4 + 1] = value;
        imageData.data[idx * 4 + 2] = value;
        imageData.data[idx * 4 + 3] = 255;
    });
    // Create a temporary canvas to scale the image
    const tempCanvas = document.createElement('canvas');
    tempCanvas.width = size;
    tempCanvas.height = size;
    const tempCtx = tempCanvas.getContext('2d');
    tempCtx.putImageData(imageData, 0, 0);
    // Scale up the image and draw it on the image canvas
    ctx.imageSmoothingEnabled = false;
    ctx.drawImage(tempCanvas, 0, 0, size, size, 0, 0, scale, scale);
    return imageCanvas;
};
const $8eae7ab5226ec05d$var$main = async ()=>{
    const [test, autoencoder] = await Promise.all([
        $8eae7ab5226ec05d$var$fetchTestData(),
        $7eII2.loadLayersModel('https://storage.googleapis.com/andypai-me/tfjs/mnist-autoencoder/model.json')
    ]);
    const table = (0, $e6lF8.default)(autoencoder);
    const architecture = document.getElementById('architecture');
    architecture.innerHTML = '' // Clear previous content
    ;
    architecture.appendChild(table);
    for (const { image: original } of test){
        const xsTensor = $7eII2.tensor2d([
            original
        ]);
        const encoded = autoencoder.predict(xsTensor);
        const image = await encoded.array();
        const reconstructed = image[0].map((pixel)=>pixel > 0.5 ? 1 : 0);
        document.getElementById('original').innerHTML = '';
        document.getElementById('reconstructed').innerHTML = '';
        document.getElementById('original').appendChild($8eae7ab5226ec05d$var$drawImage(original));
        document.getElementById('reconstructed').appendChild($8eae7ab5226ec05d$var$drawImage(reconstructed));
        await new Promise((resolve)=>{
            setTimeout(resolve, 2000);
        });
    }
};
$8eae7ab5226ec05d$var$main();


//# sourceMappingURL=mnist-autoencoder.f3a564bf.js.map
